const API = import.meta.env.VITE_API_URL || '';

export function api(path, opts = {}) {
  const { skipAuth, ...fetchOpts } = opts;
  const headers = {
    'Content-Type': 'application/json',
    ...(fetchOpts.headers || {}),
  };
  if (!skipAuth) {
    const token = localStorage.getItem('sqetrack_token') || '';
    headers['Authorization'] = `Bearer ${token}`;
  }
  return fetch(API + path, {
    ...fetchOpts,
    headers,
  }).then(r => {
    if (r.status === 401 && !skipAuth) {
      localStorage.removeItem('sqetrack_token');
      window.location.href = '/login';
      return {};
    }
    return r.json();
  });
}

// Fire-and-forget event tracker — never throws
export function trackEvent(event, properties = {}) {
  api('/api/events', {
    method: 'POST',
    body: JSON.stringify({ event, properties }),
  }).catch(() => {});
}

export function downloadExport() {
  const token = localStorage.getItem('sqetrack_token') || '';
  fetch(API + '/api/export', {
    headers: { 'Authorization': `Bearer ${token}` },
  })
    .then(r => r.blob())
    .then(blob => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `SQE_Revision_${new Date().toISOString().slice(0, 10)}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    });
}
